import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'redeem',
    loadComponent: () =>
      import('./pages/redeem/redeem.component').then((m) => m.RedeemComponent),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
  },
];
